module.exports = __webpack_public_path__ + "static/media/aeronave.cbdf1f4b.glb";